import React, {Component, Fragment} from 'react';
/*import "../styles/SearchBar.scss";*/


/**
 * This is a part of the searchbar component that displays the filter items and searchbar.
 * 
 * It is a complete re-write of the prior searchbar component, please refer to ACH-328
 * for more details. 
 */
class FilterDropDown extends Component{
    constructor(props){
        super(props);

        this.state={
            selected: false,
            label: ""
        }
    }

    generateItems(){
        if(this.props.Tags){
			if(this.props.Tags.length===0)
				return (<p className="error">Please remove other filters applied to use the filters in this section.</p>);

			let menuItems=[],
				index=0,
				arr_size=Math.ceil(this.props.Tags.length/3);

			while(index<this.props.Tags.length)
				menuItems.push(
					<div key={index} className="dropdown-column">
						{this.props.Tags.slice(index,index+=arr_size).map((element,i)=>(
							<div key={i} 
								id={element.Tag_ID} 
								onClick={(e)=>{this.props.onItemSelect(element.Tag_ID)}} 
								style={this.props.selectedTags.includes(element.Tag_ID)?{fontWeight: 'bold'} : {fontWeight: 'lighter'}}
								className="dropdown-item"
							>{element.Label}</div>))
						}
					</div>
				)
			
            return menuItems;
        }
    }

    render() {
        return (
           <Fragment>
               <div className={this.props.selected ? "dropdown-container" : "dropdown-container-hidden"}>
                    {this.generateItems()}
               </div>
           </Fragment>
        )
    }
}

export default FilterDropDown;  